export const hasRenderableImage = image =>
  Boolean(
    image?.url ||
    image?.localFile ||
    image?.gatsbyImageData ||
    image?.childImageSharp ||
    image?.publicURL,
  )

export const hasImageOrVideo = data => {
  const imageOrVideo = data?.imageOrVideo ?? data

  return Boolean(
    (imageOrVideo?.isVideoSelected &&
      (imageOrVideo?.videoURL ||
        imageOrVideo?.mobileVideoURL ||
        imageOrVideo?.videoImageFallback)) ||
    hasRenderableImage(imageOrVideo?.desktopImage) ||
    hasRenderableImage(imageOrVideo?.mobileImage),
  )
}
